import React from "react";
import { Button, Card, Tag, Input, Table, Empty } from "antd";
import Apibank from "../../api/Apibank";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { DetailModel } from "../../components/Model/index-model";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { t } from "i18next";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { getRandomuserParams, showToast } from "../../utils";
import { FormatBanks } from "../../helpers/formatBank";
import { BankOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import { tagsBageStatus } from "../../helpers/tagsBage";
import { SearchMain } from "../../components/Search";
import AppContext from "../../components/AppContext";

const { Search } = Input;

class Index extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      show: false,
      showModelAdd: false,
      showModelEdit: false,
      isData: null,
      isLoad: false,
      isSearching: false,
      customDate: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      formData: {
        username: "",
        password: "",
      },
      dataTable: [],
      dataTableToday: [],
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
    };
    // Binding methods
    this.setLoading = this.setLoading.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.fetchDataToday = this.fetchDataToday.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onTab1Change = this.onTab1Change.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.fetchDataToday();
  }

  componentDidUpdate(prevProps, prevState) {
    const { tableParams, activeTabKey1 } = this.state;
    const { tableParams: prevTableParams, activeTabKey1: prevActiveTabKey1 } =
      prevState;

    // Trigger fetchData based on changes
    if (activeTabKey1 !== prevActiveTabKey1) {
      if (activeTabKey1 === "tab1") {
        this.fetchDataToday();
      } else {
        this.fetchData();
      }
      return;
    }

    const paginationChanged =
      tableParams.pagination?.current !== prevTableParams.pagination?.current ||
      tableParams.pagination?.pageSize !== prevTableParams.pagination?.pageSize;
    const sortChanged =
      tableParams.sortOrder !== prevTableParams.sortOrder ||
      tableParams.sortField !== prevTableParams.sortField;
    const filtersChanged =
      JSON.stringify(tableParams.filters) !==
      JSON.stringify(prevTableParams.filters);

    if (
      activeTabKey1 === "tab2" &&
      (paginationChanged || sortChanged || filtersChanged)
    ) {
      this.fetchData();
    }
  }

  setLoading = (_loading) => {
    this.setState({ isLoad: _loading });
  };

  fetchDataToday = async () => {
    this.setLoading(true);
    const { tableParams } = this.state;
    const params = getRandomuserParams(tableParams);
    const today = moment().format("YYYY-MM-DD");

    let itemParam = {
      limit: params.limit,
      offset: params.page,
      startDate: today,
      endDate: today,
      sort: tableParams.sortField || "id",
      order:
        tableParams.sortOrder === "ascend"
          ? "asc"
          : tableParams.sortOrder === "descend"
            ? "desc"
            : undefined,
    };

    if (tableParams.filters.refUuid) {
      itemParam.refUuid = tableParams.filters.refUuid;
    }
    if (tableParams.filters.status && tableParams.filters.status.length > 0) {
      itemParam.status = tableParams.filters.status;
    }

    try {
      const res = await Apibank.getDataClient_transfer(itemParam);
      if (res.data.success) {
        const fetchedData = Array.isArray(res.data.data.rows)
          ? res.data.data.rows
          : [];

        this.setState((prevState) => ({
          dataTableToday: fetchedData,
          tableParams: {
            ...prevState.tableParams,
            pagination: {
              ...prevState.tableParams.pagination,
              total: res.data.data.count,
            },
          },
        }));
      } else {
        showToast("error", res.message || "Failed to fetch today's data.");
        this.setState({ dataTableToday: [] });
      }
    } catch (error) {
      showToast("error", error.message || "Failed to fetch today's data.");
      console.error("Error fetching today's data:", error);
      this.setState({ dataTableToday: [] });
    } finally {
      this.setLoading(false);
    }
  };

  fetchData = async () => {
    this.setLoading(true);
    const { tableParams, customDate } = this.state;
    const params = getRandomuserParams(tableParams);

    let itemParam = {
      limit: params.limit,
      offset: params.page,
      startDate: customDate?.startDate,
      endDate: customDate?.endDate,
      sort: tableParams.sortField || "id",
      order:
        tableParams.sortOrder === "ascend"
          ? "asc"
          : tableParams.sortOrder === "descend"
            ? "desc"
            : undefined,
    };

    if (tableParams.filters.refUuid) {
      itemParam.refUuid = tableParams.filters.refUuid;
    }
    if (tableParams.filters.status && tableParams.filters.status.length > 0) {
      itemParam.status = tableParams.filters.status;
    }

    try {
      const res = await Apibank.getDataClient_transfer(itemParam);
      if (res.data.success) {
        const fetchedData = Array.isArray(res.data.data.rows)
          ? res.data.data.rows
          : [];

        this.setState((prevState) => ({
          dataTable: fetchedData,
          tableParams: {
            ...prevState.tableParams,
            pagination: {
              ...prevState.tableParams.pagination,
              total: res.data.data.count,
            },
          },
        }));
      } else {
        showToast("error", res.message || "Failed to fetch data.");
        this.setState({ dataTable: [] });
      }
    } catch (error) {
      showToast("error", error.message || "Failed to fetch data.");
      console.error("Error fetching data:", error);
      this.setState({ dataTable: [] });
    } finally {
      this.setLoading(false);
    }
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState((prevState) => ({
      tableParams: {
        ...prevState.tableParams,
        pagination: {
          ...prevState.tableParams.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        filters: {
          ...prevState.tableParams.filters,
          ...filters,
          refUuid: filters.refUuid
            ? filters.refUuid[0]
            : prevState.tableParams.filters.refUuid,
        },
        sortField: sorter.field,
        sortOrder: sorter.order,
      },
    }));
  };

  onSearch = (value) => {
    this.setState(
      (prevState) => ({
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
          },
          filters: {
            ...prevState.tableParams.filters,
            refUuid: value,
          },
        },
      }),
      () => {
        if (this.state.activeTabKey1 === "tab1") {
          this.fetchDataToday();
        } else {
          this.fetchData();
        }
      },
    );
  };

  onTab1Change = (key) => {
    this.setState({ activeTabKey1: key });
  };

  handleSearch = (value) => {
    if (value) {
      this.setState(
        (prevState) => ({
          customDate: {
            startDate: value.startDate
              ? moment(value.startDate.$d).format("YYYY-MM-DD")
              : null,
            endDate: value.endDate
              ? moment(value.endDate.$d).format("YYYY-MM-DD")
              : null,
          },
          tableParams: {
            ...prevState.tableParams,
            pagination: {
              ...prevState.tableParams.pagination,
              current: 1,
            },
            filters: {
              ...prevState.tableParams.filters,
              status: value.status,
            },
          },
        }),
        () => this.fetchData(),
      );
    }
  };
  handleIsSearching = (_e) => {
    this.setState({ isSearching: _e });
  };
  render() {
    const { isInbox } = this.props;
    const {
      activeTabKey1,
      show,
      isData,
      isLoad,
      tableParams,
      dataTable,
      dataTableToday,
    } = this.state;
    const handleClose = () => {
      this.setState({
        show: false,
        showModelAdd: false,
        showModelEdit: false,
        isData: null,
      });
    };

    const tabList = [
      { key: "tab1", tab: t("transfer list today.") },
      { key: "tab2", tab: t("Select time period.") },
    ];

    const columns = [
      { title: t("ID "), dataIndex: "id", sorter: false, key: "id" },
      {
        title: t("From"),
        dataIndex: "FormAccount",
        key: "FormAccount",
        render: (item) =>
          item ? (
            <span style={{ cursor: "copy" }}>
              <b>
                <span
                  className={`text-${
                    item.accountType === "deposit" ? "success" : "danger"
                  }`}
                  style={{ fontWeight: "600" }}
                >
                  [{t(item.accountType)}]
                </span>{" "}
                - {FormatBanks(item.bankId)}, {item.accountNumber}
              </b>
              <br className="sm-hiden" />
              <>{item.accountName}</>
            </span>
          ) : (
            <em style={{ color: "#888" }}>
              <small>{t("No data")}</small>
            </em>
          ),
      },
      {
        title: t("To"),
        key: "TOAccount",
        dataIndex: "TOAccount",
        render: (item) => (
          <span style={{ cursor: "copy" }}>
            <b>
              <span
                className={`text-${
                  item.accountType === "deposit" ? "success" : "danger"
                }`}
                style={{ fontWeight: "600" }}
              >
                [{t(item.accountType)}]
              </span>{" "}
              - {FormatBanks(item.bankId)}, {item.accountNumber}
            </b>
            <br className="sm-hiden" />
            <>{item.accountName}</>
          </span>
        ),
      },
      {
        title: t("Amount"),
        key: "amount",
        sorter: false,
        dataIndex: "amount",
        render: (amount) => (
          <span style={{ fontWeight: "700" }}>
            {Intl.NumberFormat().format(amount)}.-
          </span>
        ),
      },
      {
        title: t("Status"),
        dataIndex: "status",
        key: "status",
        render: (status) => <Tag color={tagsBageStatus(status)}>{status}</Tag>,
      },
      {
        title: t("note"),
        key: "note",
        dataIndex: "note",
        render: (note) => (
          <span>
            {note ? (
              note
            ) : (
              <small>
                <em style={{ color: "#888" }}>{t("No note")}</em>
              </small>
            )}
          </span>
        ),
      },
      {
        title: t("ทำรายการโดย"),
        key: "admin",
        dataIndex: "admin",
        render: (admin) => (
          <span style={{ color: "#3eacff" }}>
            <UserSwitchOutlined style={{ fontSize: "16px" }} /> {admin.name}
          </span>
        ),
      },
      {
        title: t("createdAt"),
        key: "created_at",
        dataIndex: "created_at",
        sorter: false,
        render: (date) => (
          <span title={moment(date).format("DD-MM-YYYY HH:mm:ss")}>
            {FormatTimeAgo(date)}
          </span>
        ),
      },
    ];

    const contentList = {
      tab1: (
        <>
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.id}
              onChange={this.handleTableChange}
              dataSource={dataTableToday}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t("No data")}
                  />
                ),
              }}
              loading={isLoad}
              pagination={{
                ...tableParams.pagination,
                showSizeChanger: true,
                locale: {
                  items_per_page: `/ ${t("paged")}`, 
                },
                showTotal: (total, range) => {
                  // คำนวณหน้าปัจจุบัน
                  const currentPage = tableParams.pagination.current;
                  // คำนวณจำนวนหน้าทั้งหมด
                  const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                  return (
                    <span>
                      {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                      <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                      <span style={{ marginLeft: 10 }}>
                        {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                      </span>
                    </span>
                  );
                },
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      ),
      tab2: (
        <>
          <SearchMain
            t={t}
            onSearch={this.handleSearch}
            activeKey1={this.context.activeKey1}
            status={""}
            handleIsSearching={this.handleIsSearching}
          />
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.id}
              onChange={this.handleTableChange}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t("No data")}
                  />
                ),
              }}
              dataSource={dataTable}
              loading={isLoad}
              pagination={{
                ...tableParams.pagination,
                showSizeChanger: true,
                locale: {
                  items_per_page: `/ ${t("paged")}`, 
                },
                showTotal: (total, range) => {
                  // คำนวณหน้าปัจจุบัน
                  const currentPage = tableParams.pagination.current;
                  // คำนวณจำนวนหน้าทั้งหมด
                  const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                  return (
                    <span>
                      {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                      <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                      <span style={{ marginLeft: 10 }}>
                        {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                      </span>
                    </span>
                  );
                },
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      ),
    };

    return (
      <>
        <DetailModel handleClose={handleClose} isData={isData} show={show} />
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("Transfer List")}
                Breadcrumb={
                  isInbox
                    ? [
                        {
                          name: removeSlashesFromPath(window.location.pathname),
                          navigate: window.location.pathname,
                        },
                      ]
                    : null
                }
              />
            <br className="sm-hiden" />
            {isInbox && (
                <Card
                  title={
                    <Link to={"/transfer"}>
                      <Button icon={<BankOutlined />}>
                        {t("transfer money")}
                      </Button>
                    </Link>
                  }
                  extra={
                    <Search
                      placeholder={t("Search by Ref UUID...")}
                      onSearch={this.onSearch}
                      enterButton
                    />
                  }
                  tabList={tabList}
                  activeTabKey={activeTabKey1}
                  onTabChange={this.onTab1Change}
                >
                  {contentList[activeTabKey1]}
                </Card>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, {})(withTranslation()(Index));
